// Email and phone patterns.
const EMAIL_RE = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
const PHONE_RE = /(\+\s?\d(?:[\s-]?\d){7,}|0\d(?:[\s-]?\d){7,})/g;

/**
 * Wraps bare email addresses and phone numbers in CMS text in anchor tags so they become tappable.
 */
export default function linkifyHtml(html: string): string {
	if (!html) return html;

	return html
		.split(/(<a\b[^>]*>[\s\S]*?<\/a>)/gi)
		.map((segment, index) => {
			// Odd segments are existing anchors, never touch them.
			if (index % 2 === 1) return segment;

			// Wrap emails first, then re-split so phone matching never scans inside the mailto anchors we just created
			// (or any other existing anchor).
			return segment
				.replace(EMAIL_RE, '<a href="mailto:$1">$1</a>')
				.split(/(<a\b[^>]*>[\s\S]*?<\/a>)/gi)
				.map((part, i) =>
					i % 2 === 1
						? part
						: part.replace(PHONE_RE, (match) => `<a href="tel:${match.replace(/[\s-]/g, '')}">${match}</a>`),
				)
				.join('');
		})
		.join('');
}
